'use strict';

/**
 * Fill the dropdowns for country, province, city and language based on the already selected values.
 * If country is selected, province and languages are updated and cities are cleared.
 * If province is selected cities are updated.
 *
 * @param {Object} data - the retrieved data from back-end
 * @param {boolean} isCountryTrigger - identify which dropdown triggers the data fetch
 */
function fillDropdowns(data, isCountryTrigger) {
  const $provinces = $('.js_sfsc-provinces');
  if (isCountryTrigger) {
    $provinces.empty();
    for (let i = 0; i < data.provinces.length; i++) {
      // IBT-4751
      if (data.provinces[i].provinceName !== 'MISSING COUNTY') {
        $provinces.append('<option value="' + data.provinces[i].provinceID + '">' + data.provinces[i].provinceName + '</option>');
      }
    }

    const $languages = $('.js_sfsc-languages');
    const selectedLanguage = $languages.val();
    $languages.empty();
    for (let i = 0; i < data.languages.length; i++) {
      $languages.append(
        '<option value="' +
          data.languages[i].languageID +
          '" ' +
          (data.languages[i].languageID === selectedLanguage ? 'selected="selected"' : '') +
          '>' +
          data.languages[i].languageName +
          '</option>'
      );
    }
    const $languageGroup = $('.js_sfsc-language-group');
    if (data.languages.length <= 2) {
      $languageGroup.addClass('d-none');
    } else {
      $languageGroup.removeClass('d-none');
    }
  }

  const $cities = $('.js_sfsc-cities');
  $cities.empty();
  for (let i = 0; i < data.cities.length; i++) {
    $cities.append('<option value="' + data.cities[i].cityID + '">' + data.cities[i].cityName + '</option>');
  }
}

module.exports = {
  handleSelectedDropdowns: function () {
    const $countryDropdown = $('.js_sfsc-countries');
    const $provinceDropdown = $('.js_sfsc-provinces');
    $countryDropdown.on('change', function () {
      const selectedCountry = $countryDropdown.val();
      const url = this.dataset.url;
      $.spinner().start();
      $.ajax({
        type: 'GET',
        url: url,
        data: {
          country: selectedCountry,
        },
        success: function success(data) {
          $.spinner().stop();
          fillDropdowns(data, true);
        },
        error: function error() {
          $.spinner().stop();
        },
      });
    });
    $provinceDropdown.on('change', function () {
      const selectedCountry = $countryDropdown.val();
      const selectedProvince = $provinceDropdown.val();
      const url = this.dataset.url;
      $.spinner().start();
      $.ajax({
        type: 'GET',
        url: url,
        data: {
          country: selectedCountry,
          province: selectedProvince,
        },
        success: function success(data) {
          $.spinner().stop();
          fillDropdowns(data, false);
        },
        error: function error() {
          $.spinner().stop();
        },
      });
    });
  },
};
